import { render } from "./FirebaseUI.vue?vue&type=template&id=414505fe&scoped=true"
import script from "./FirebaseUI.vue?vue&type=script&lang=ts"
export * from "./FirebaseUI.vue?vue&type=script&lang=ts"

import "./FirebaseUI.vue?vue&type=style&index=0&id=414505fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-414505fe"

export default script